import { createAction } from '../../../store.model';
import { ImprovementGroupDto, PerformanceClassDto } from '../../core';
import { ActionType } from '../main.action';
import { FilterItemView } from '../model/filter-item-view.model';

export interface ApplyFilterSelection {
    selection: Array<FilterItemView<PerformanceClassDto | ImprovementGroupDto>>;
}

export const applyFilterSelection = createAction<
    ActionType,
    ApplyFilterSelection
>(ActionType.MI2_MAIN__APPLY_FILTER_SELECTION);
